import { EditorState, type Extension } from '@codemirror/state';
import {
  EditorView,
  placeholder as placeholderExtension,
} from '@codemirror/view';

import {
  ariaAttributesCompartment,
  disabledPropCompartment,
  placeholderCompartment,
  readOnlyPropCompartment,
} from '../editor-state-configs/editor-config.js';

export const DynamicFilterFieldConfigurations: (args: {
  ariaAttributes: {
    'aria-describedby': string;
    'aria-disabled'?: string;
    'aria-activedescendant'?: string;
    'aria-controls'?: string;
    'aria-label': string;
    'aria-haspopup': string;
    'aria-details'?: string;
    'aria-labelledby'?: string;
    'aria-autocomplete': string;
  };
  disabled: boolean;
  readOnly: boolean;
  placeholder: string;
}) => Extension = ({ ariaAttributes, disabled, readOnly, placeholder }) => [
  /**
   * Aria attributes
   */
  ariaAttributesCompartment.of(EditorView.contentAttributes.of(ariaAttributes)),

  /**
   * Disabled
   */
  disabledPropCompartment.of(EditorView.editable.of(!disabled)),

  /**
   * Placeholder
   */
  placeholderCompartment.of(placeholderExtension(placeholder)),

  /**
   * Read-only
   */
  readOnlyPropCompartment.of(EditorState.readOnly.of(readOnly)),
];
